import { render, staticRenderFns } from "./ManuscriptEditorPage.vue?vue&type=template&id=783dc239&scoped=true"
import script from "./ManuscriptEditorPage.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorPage.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorPage.vue?vue&type=style&index=0&id=783dc239&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783dc239",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783dc239')) {
      api.createRecord('783dc239', component.options)
    } else {
      api.reload('783dc239', component.options)
    }
    module.hot.accept("./ManuscriptEditorPage.vue?vue&type=template&id=783dc239&scoped=true", function () {
      api.rerender('783dc239', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ManuscriptEditorPage.vue"
export default component.exports